import clsx from 'clsx'
import { isFrsRoute } from '../../Utils/frs-helpers'
import SelectField from '../Shared/SelectField'
import { useRoutes } from '../../Hooks/routes/useRoutes'
import Passengers from './Passengers'
import PassengerIcon from '../../Icons/PassengerIcon'
import { useVehicles } from '../../Hooks/vehicles/useVehicles'
import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import { useTranslation } from 'react-i18next'

export default function PassengersSelector() {
  const { selectedRoute, isRoutesLoading } = useRoutes()
  const { selectedPassengers, isVehiclesLoading, numberOfPassengers } = useVehicles()
  const { activeField, closeIfActive, toggleField } = useActiveSelectField()
  const { t } = useTranslation()

  const routeCode = selectedRoute?.routeCode ?? ''
  const isHidden = isFrsRoute(routeCode)

  const dataAttrList = [
    { name: 'selected-adults', value: `${selectedPassengers?.adults}` },
    { name: 'selected-children', value: `${selectedPassengers?.children}` },
    { name: 'child-ages', value: `${selectedPassengers?.childrenAges?.join(',')}` },
    { name: 'selected-pets', value: `${selectedPassengers?.pets}` },
  ]

  const displayValue =
    selectedPassengers?.pets && selectedPassengers?.pets > 0 ? `${numberOfPassengers} + ${t('PETS')}` : `${numberOfPassengers}`

  return (
    <div
      className={clsx(
        'ts-h-[58px] ts-w-full ts-col-span-12 md:ts-col-span-6 lg:ts-col-auto ts-box-border ts-border lg:ts-border-r-0 ts-border-solid ts-border-cvi-grey-grey200',
        isHidden && 'ts-hidden'
      )}
    >
      <SelectField
        dataAttrList={dataAttrList}
        title={`${t('PASSENGERS')} & ${t('PETS')}`}
        isLoading={isRoutesLoading || isVehiclesLoading}
        isOpen={activeField === ActiveSelectField.PASSENGER}
        fieldName="passenger"
        value={displayValue}
        icon={<PassengerIcon size="md" />}
        visibleRows={selectedPassengers?.adults && selectedPassengers.pets ? 2 : 1}
        onClick={(clickedOutside) => {
          !isRoutesLoading && !isVehiclesLoading && toggleField(ActiveSelectField.PASSENGER, clickedOutside)
        }}
        onClose={() => closeIfActive(ActiveSelectField.PASSENGER)}
      >
        {selectedPassengers && <Passengers initialPassengers={selectedPassengers} />}
      </SelectField>
    </div>
  )
}
